class Datepicker {
    init(elem) {
        let datetpicker = jQuery(elem).datepicker({
            dateFormat: "yy-mm-dd"
        });

        datetpicker.datepicker('show');
    }
}